module.exports = __webpack_public_path__ + "img/user-img.bcb66519.svg";